import type { ComponentProps } from "react";

import { cn } from "../foundations/cn.js";

/**
 * Long-form text written as plain semantic HTML (headings, paragraphs, lists, links, emphasis),
 * set in the theme's type roles from the wrapper so the document itself carries no classes:
 * h2 as heading-h1, h3 as heading-h2, body as body-b1, links in the accent text color. A
 * heading or section with an id leaves room for the floating nav when a link scrolls to it.
 */
export function Prose({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "font-body text-body-b1 text-text-secondary [overflow-wrap:anywhere]",
        "[&_h2]:mt-10 [&_h2]:text-heading-h1 [&_h2]:text-text-primary [&_h3]:mt-6 [&_h3]:text-heading-h2 [&_h3]:text-text-primary",
        "[&_p]:mt-3 [&_ul]:mt-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:mt-3 [&_ol]:list-decimal [&_ol]:pl-6 [&_li]:mt-1.5 [&_li]:pl-1",
        "[&_strong]:font-semibold [&_strong]:text-text-primary [&_u]:underline-offset-4",
        "[&_a]:text-accent-text [&_a]:underline [&_a]:underline-offset-4 [&_a:hover]:text-text-primary [&_a]:rounded-xs [&_a:focus-visible]:focus-ring [&_a]:outline-hidden",
        "[&_section]:scroll-mt-28 [&_[id]]:scroll-mt-28",
        className,
      )}
      {...props}
    />
  );
}
